import Grid2 from '@shared/components/Grid2';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { SectionDark1 } from '../../components/ColoredSection';

const Gegensaetze: FC = () => (
  <SectionDark1>
    <Grid2 spacing={{ md: '2rem', xs: '0' }}>
      <Grid2.Item>
        <H2>Systema - Gegensätze vereint</H2>
        <Paragraph>
          Systema-Training findet meist langsam und geradezu liebevoll statt. Alle Bewegungen werden
          mit größtmöglicher Präzision, Hingabe und Genuss ausgeführt.
        </Paragraph>
        <Paragraph>
          Es wird stets darauf geachtet sich selbst zu entspannen und auch dem Partner ein
          angenehmes und angstfreies Bewegen zu ermöglichen.
        </Paragraph>
        <Paragraph>
          Auf diese Weise wirkt das Training beruhigend auf das Nerven-System, entspannt den Körper
          und eröffnet ganz neue Dimensionen der Balance, Koordination und Körper-Kontrolle.
        </Paragraph>
        <Paragraph>
          Es erzeugt einen einzigartigen Genuss und eine wundervolle Verbindung mit dem eigenen
          Körper.
        </Paragraph>
        <Paragraph>
          Das Training wird Dir ein außergewöhnliches Maß an Koordination, Aufmerksamkeit,
          Achtsamkeit und Konzentration vermitteln.
        </Paragraph>
      </Grid2.Item>
      <Grid2.Item>
        <Paragraph margin={{ top: '0' }}>
          Gleichzeitig entwickelt das langsame, präzise und harmonische Training ein unglaubliches
          Verständnis für die Biomechanik des Menschen. Du wirst lernen, selbst kleinste Spannungen
          des Gegners auszunutzen. Dabei wirst Du nicht sinnlos mit Kraft gegen Kraft arbeiten,
          sondern den jeweils einfachsten Weg wählen.
        </Paragraph>
        <Paragraph>
          Im Ernstfall kannst Du Nervendruck- und Vital-Techniken mit Hebeln, Würfen und Schlägen
          kombinieren. Auf diese Weise hast Du die Chance, gegen schwerere oder stärkere Gegner zu
          bestehen.
        </Paragraph>
        <Paragraph>
          Wenn es notwendig sein sollte, kann man einen Selbstverteidigungs-Spezialisten in kurzer
          Zeit ausbilden.
        </Paragraph>
        <Paragraph>
          Alle Bewegungen führen wir jeweils ohne Kraft aus, weshalb sich unser Training für
          Menschen jeden Alters und jedes Geschlechts eignet.
        </Paragraph>
        <Paragraph bold>Bist Du bereit für eine völlig neue Erfahrung?</Paragraph>
      </Grid2.Item>
    </Grid2>
  </SectionDark1>
);

export default memo(Gegensaetze);
